<template>
    <div class="Show">
        <van-nav-bar
                title="新用户注册"
                left-text=""
                left-arrow
                @click-left="$router.back(-1)"
        />
        <div class="cmain">
            <van-cell-group>
                <van-field
                        v-model="user.phoneNumber"
                        clearable
                        label="手机号码"
                        :error-message="userError.phoneNumber"
                        placeholder="不需要加+61或+81"
                        @keydown="userError.phoneNumber=''"
                />
                <van-field
                        v-model="user.nickName"
                        clearable
                        label="昵称"
                        placeholder="请输入您的昵称"
                        @keydown="userError.nickName=''"
                />
                <van-field
                        v-model="user.password"
                        type="password"
                        label="登录密码"
                        :error-message="userError.password"
                        placeholder="账户登录密码"
                        @keydown="userError.password=''"
                />
                <van-field
                        v-model="user.suerPassword"
                        type="password"
                        label="确认密码"
                        :error-message="userError.suerPassword"
                        placeholder="再次输入密码"
                        @keydown="userError.suerPassword=''"
                />
                <!--<van-field
                        v-model="user.emailAddress"
                        clearable
                        label="Email"
                        :error-message="userError.emailAddress"
                        placeholder="输入Email地址"
                        @keydown="userError.emailAddress=''"
                />-->
            </van-cell-group>
            <div style="height: 30px"></div>
            <div class="register_btn_box">
                <van-button type="primary" size="large" v-if="!loading" @click="register()">注册</van-button>
                <van-button loading type="primary" disabled  size="large" loading-text="正在提交注册..." v-if="loading" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Register",
        data() {
            return {
                loading: false,
                user: {
                    shopId: null,
                    phoneNumber: "",
                    password: "",
                    suerPassword: "",
                    nickName: "",
                    emailAddress: ""
                },
                userError: {
                    phoneNumber: "",
                    password: "",
                    suerPassword: "",
                    nickName: "",
                    emailAddress: ""
                }
            }
        },
        methods: {
            register() {
                var that = this
                var valid = window.consts.validate
                var shopId = this.$route.query.shopId
                if(!this.user.phoneNumber) {
                    this.userError.phoneNumber = "手机号码格式不对!"
                    return false
                } else if (!valid.password.test(this.user.password)) {
                    this.userError.password = "密码格式不正确!"
                    return false
                } else if (this.user.password != this.user.suerPassword) {
                    this.userError.suerPassword ="两次密码不一致!"
                    return false
                } 
                /*else if (this.user.emailAddress && !valid.email.test(this.user.emailAddress)) {
                    this.userError.emailAddress = "Email格式不正确!"
                    return false
                }*/
                this.loading = true
                let resgistText = "注册成功!"
                if (shopId && shopId > 0) {
                    this.user.shopId = shopId
                    resgistText = "注册并绑定成功!"
                }
                this.$axios.post(window.consts.apis.register, this.user).then(res => {
                    this.loading = false
                    if (res.success) {
                        // this.$refs.regForm.resetFields();
                        this.$dialog.alert({
                            title: "提示",
                            message: resgistText
                        }).then(reg => {
                            that.skipToUrl()
                        })
                    } else {
                        this.$toast.fail(res.error.message)
                    }
                }, error => {
                    this.loading = false
                    this.$toast.fail("注册失败!")
                })
            },
            skipToUrl() {
                this.$router.push({ path: '/m/login' })
            }
        }
    }
</script>

<style scoped>
    .register_btn_box {
        width: 96%;
        margin:0 auto;
    }
    .van-cell-group {
        margin-top:25px;
    }
</style>